import { render, staticRenderFns } from "./panelSetting.vue?vue&type=template&id=0a853dfe&scoped=true&"
import script from "./panelSetting.vue?vue&type=script&lang=js&"
export * from "./panelSetting.vue?vue&type=script&lang=js&"
import style0 from "./panelSetting.vue?vue&type=style&index=0&id=0a853dfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a853dfe",
  null
  
)

export default component.exports